import { render, staticRenderFns } from "./FacilityEditFormPriority.vue?vue&type=template&id=1fab4ff2&"
import script from "./FacilityEditFormPriority.vue?vue&type=script&lang=js&"
export * from "./FacilityEditFormPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports